import { ready } from "@rootreeweb/js-lib";

import pageSelect from "./pageSelect.js";
import videoPlayer from "./videoPlayer.js";

ready(() => {
	videoPlayer();
	pageSelect();
});
